// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const ToastContainer = styled.div `
  right: 24px;
  bottom: 24px;
  gap: 12px;
  z-index: 9998;
  display: flex;
  position: fixed;
  max-width: 420px;
  flex-direction: column-reverse;

  .root-app_toast {
    gap: 16px;
    display: flex;
    padding: 16px;
    align-items: flex-start;
    justify-content: space-between;
    border-left: 4px solid var(--color-neutral-400);
    border-radius: var(--border-radius-default);
    background-color: var(--color-contrast-white);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);

    &.success {
      border-left-color: var(--color-feedback-success-500);
    }

    &.error {
      border-left-color: var(--color-feedback-danger-500);
    }

    &.info {
      border-left-color: var(--color-feedback-info-500);
    }

    p {
      margin: 0;
      color: var(--color-neutral-600);
      font-size: var(--font-size-sm);
    }

    button {
      border: 0;
      padding: 0;
      line-height: 1;
      cursor: pointer;
      font-size: var(--font-size-default);
      color: var(--color-neutral-500);
      background-color: transparent;
    }
  }
`;
//# sourceMappingURL=style.js.map